<template>
	<footer
		class="footer py-3 bg-light mt-3 px-3 d-flex align-items-center justify-content-center"
	>
		<p class="text-muted small mb-0">
			All rights reserved @
			<a href="https://coderootz.com/" target="new">coderootz</a> &copy;
			{{ new Date().getFullYear() }}
		</p>
	</footer>
</template>

<script>
	export default {
		name: "TheFooter",
	};
</script>

<style>
	footer {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
	}
</style>
